import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Escritorio from "@/pages/Escritorio";
import Atuacao from "@/pages/Atuacao";
import PracticeArea from "@/pages/PracticeArea";
import Socios from "@/pages/Socios";
import Partner from "@/pages/Partner";
import Contato from "@/pages/Contato";
import InfoLegais from "@/pages/InfoLegais";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/escritorio" element={<Escritorio />} />
          <Route path="/atuacao" element={<Atuacao />} />
          <Route path="/atuacao/:slug" element={<PracticeArea />} />
          <Route path="/socios" element={<Socios />} />
          <Route path="/socios/:slug" element={<Partner />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/informacoes-legais" element={<InfoLegais />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" toastOptions={{ style: { background: "#12172b", color: "#f4f1e9", border: "1px solid rgba(201,162,75,0.3)" } }} />
    </BrowserRouter>
  );
}

export default App;
